import { combineReducers } from "redux";
import payReducer from  './payReducer'

export default combineReducers({
  pay:payReducer
});
